import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ObjectCompareContractDialogComponent } from '../../../Views/Work/Accounts/proprietary/dialogs/object-compare-dialog/object-compare-contract-dialog/object-compare-contract-dialog.component';

@Injectable()
export class ObjectCompareService {
    modalRef: NgbModalRef;

    constructor(private modalService: NgbModal, private injector: Injector) { }

    compareContracts(contractIDs: string) {
        this.modalRef = this.modalService.open(ObjectCompareContractDialogComponent, {
            centered: true,
            size: 'lg',
            injector: this.injector,
            backdrop: 'static',
            windowClass: 'ep-modal-panel-double'
        });
        this.modalRef.componentInstance.showCloseButton = false;
        this.modalRef.componentInstance.dynamicData = { modal: true, options: contractIDs };
    }
}
